import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Profile from '@/components/Profile'
import Portfolio from '@/components/Portfolio'
import Contact from '@/components/Contact'
import Project from '@/components/Project'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    }, {
      path: '/profile',
      name: 'Profile',
      component: Profile
    }, {
      path: '/portfolio',
      name: 'Portfolio',
      component: Portfolio
    }, {
      path: '/portfolio/:project',
      name: 'Project',
      component: Project,
      params: true
    }, {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js